import * as React from "react";

import { SSOActions } from "./actions";
import { ssoInitialState, ssoReducer } from "./reducers";
import { SSOState } from "./states";
import { JSX } from "react";

interface AccountProps {
  clientId: number;
  setClientId: React.Dispatch<React.SetStateAction<number>>;
  ssoDispatch: React.Dispatch<SSOActions>;
  ssoState: SSOState;
}

export const AccountContext = React.createContext<Partial<AccountProps>>({});

export const AccountProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [clientId, setClientId] = React.useState<number>();
  const [ssoState, ssoDispatch] = React.useReducer(ssoReducer, ssoInitialState);

  return (
    <AccountContext.Provider
      value={{
        clientId,
        setClientId,
        ssoDispatch,
        ssoState,
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};
